'use client';

import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useState, useEffect } from 'react';

import ShareIcon from '@/fo/icons/base/icons/share.svg';
import { toastBase } from '@/fo/ui/kit/toast/base';

import { styles } from './UiKitLinkCopy.styles';

export interface UiKitLinkCopyProps {
  className?: string;
  link: string;
  needOrigin?: boolean;
  textClassName?: string;
}

export function UiKitLinkCopy({
  className,
  link,
  needOrigin = false,
  textClassName
}: UiKitLinkCopyProps) {
  const slots = styles();
  const t = useTranslations();
  const [url, setUrl] = useState<string>('');
  const pathname = usePathname();
  useEffect(() => {
    if (needOrigin) {
      setUrl(`${window.location.origin}/${link}`);
    } else {
      setUrl(link);
    }
  }, [needOrigin, link]);

  const onLinkCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      toastBase(t('The link is copied'));

      if (
        pathname === '/product/besprovodnoy-pylesos-dreame-r10s-essential-aqua/'
      ) {
        const img = new Image();

        img.src =
          'https://ad.new-programmatic.com/conv?aid=12479&convid=10935&random=##RANDOM=##';
      }
    });
  };

  return (
    <button
      onClick={onLinkCopy}
      className={slots.base({ className })}
    >
      <ShareIcon className={slots.icon()} />
      <span className={slots.text({ className: textClassName })}>
        {t('Share')}
      </span>
    </button>
  );
}
